export default __webpack_public_path__ + "static/media/bold.308e82a7.svg";